import React from 'react';
import RMDAmount from 'src/components/Sell/RMD/RMDAmount';
import If from 'src/components/Shared/If/If';
import { AutomaticSellDistributionAmount } from '../AutomaticSellDistributionAmount';
import { useSelector } from 'react-redux';
import {
  getIsRMDEligible,
  getShowDashboard,
} from '../../../redux/modules/RMD/RMDSetting.selectors';
import { getModalsSeen } from '../../../redux/modules/modals/modals.selectors';

export const AutoSellFundEditor = ({
  isSalesforceRep,
  customerWebViewEnabled,
  actions,
  deliveryMethod,
  fund,
  hasAPP,
  hasNotInheritedSEPOrSimpleIRA,
  marketVolatility,
  personalData,
  RMData,
  transactionLimit,
  userAddress,
}) => {
  const { isFundRMDEligible } = fund;
  const isRMDEligible = useSelector(getIsRMDEligible);
  const modalsSeen = useSelector(getModalsSeen);
  const showRmdDashboardLink = useSelector(getShowDashboard);
  const showRMDSection = hasNotInheritedSEPOrSimpleIRA && !hasAPP;
  return (
    <React.Fragment>
      <If test={!isFundRMDEligible || !showRMDSection}>
        <AutomaticSellDistributionAmount
          {...{
            isSalesforceRep,
            customerWebViewEnabled,
            actions,
            deliveryMethod,
            fund,
            marketVolatility,
            personalData,
            RMData,
            transactionLimit,
            userAddress,
            modalsSeen,
          }}
        />
      </If>
      <If
        test={
          personalData &&
          isRMDEligible &&
          isFundRMDEligible &&
          showRMDSection &&
          showRmdDashboardLink
        }
      >
        {!customerWebViewEnabled && isSalesforceRep ? (
          <span>
            {/*TODO: Remove when another way to check the box is found*/}
            <AutomaticSellDistributionAmount
              {...{
                isSalesforceRep,
                customerWebViewEnabled,
                actions,
                deliveryMethod,
                fund,
                marketVolatility,
                personalData,
                RMData,
                transactionLimit,
                userAddress,
                modalsSeen,
              }}
              showHeader
            />
          </span>
        ) : (
          <span>
            <div className="sell-fund-editor-rmd-eligible-container">
              <RMDAmount actions={actions} fund={fund} />
              <AutomaticSellDistributionAmount
                {...{
                  isSalesforceRep,
                  customerWebViewEnabled,
                  actions,
                  deliveryMethod,
                  fund,
                  marketVolatility,
                  personalData,
                  RMData,
                  transactionLimit,
                  userAddress,
                  modalsSeen,
                }}
                showHeader
              />
            </div>
          </span>
        )}
      </If>
    </React.Fragment>
  );
};
